export interface Task {
  key      : string,
  adminOnly: boolean,
  title    : string,
  message  : string,
  progress : string,
  link     : string
};



// WEBPACK FOOTER //
// /Users/itu/Desktop/impreso_updated_sheets/impresocloud/www/client/src/app/models/task.model.ts